<script>
export default {
    name: "ChatMessage",
    props: { text: String },
    render(createElement, context) {
        const URLMatcher = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm;

        if(this.text.match(new RegExp(URLMatcher)) === null) {
            return this._v(this.text);
        } else {
            return createElement('a', {attrs: {href: this.text}}, this.text);
        }
    },
};
</script>